import React from 'react';
import { IconChevronLeftRounded } from 'wg-fe-ui';
import { Flex } from '@wegroup/design-system';
import styled from 'styled-components';

interface Props {
  onClick: () => void;
}

const ScrollDownButton: React.FC<React.PropsWithChildren<Props>> = ({
  onClick,
}) => {
  return (
    <Flex
      onClick={onClick}
      alignItems="center"
      justifyContent="center"
      bg="primary.400"
      borderRadius="full"
      flexDirection="column"
      w="4.4rem"
      h="4.4rem"
      cursor="pointer"
      _active={{
        bg: 'primary.500',
      }}
      transition="0.1s"
    >
      <StyledChevron color="white" />
      <StyledChevron color="white" />
    </Flex>
  );
};

export default ScrollDownButton;

const StyledChevron = styled(IconChevronLeftRounded)`
  width: 2.8rem;
  transform: rotate(-90deg);

  &:first-of-type {
    margin-bottom: -2.4rem;
  }
`;
